import { PurchaseOrderReceiptStock } from './purchase-order-receipt-stock';

export interface PurchaseOrderReceiptsReport {
  orderNo: string;
  orderType: string;
  contractNo: string;
  dateOrdered: Date;
  supplierOrderNo: string;
  supplierOrderRef: string;
  productKey: string;
  description: string;
  enteredBy: string;
  orderTotal: number;
  unit: string;

  purchaseReceiptStockItems: PurchaseOrderReceiptStock[];
}
